import InsurancesAPI from '@api/insurancesAPI'

import { initialQueryState } from '@models/apiBase'
import { Option } from '@models/option'

import { AsyncPaginateSelectField, AsyncPaginateSelectFieldProps } from '@components/Form/AsyncPaginateSelect'

import TypeUtil from '@/utils/typeUtil'

type Props<IsMulti extends boolean> = Omit<AsyncPaginateSelectFieldProps<IsMulti>, 'onSearch'>

export const QueueNumberInsuranceSelectField = <IsMulti extends boolean = false>(props: Props<IsMulti>) => {
  const searchDebounce = async (keyword: string, page: number) => {
    const { data } = await InsurancesAPI.getOptionsForQueueNumber({
      ...initialQueryState,
      page,
      keyword: TypeUtil.isEmpty(keyword) ? null : keyword,
    })

    if (data) {
      return {
        ...data,
        nodes: data.nodes.map(
          (node) =>
            new Option({
              label: node.name,
              value: node.id,
            })
        ),
      }
    }

    return undefined
  }

  return (
    <AsyncPaginateSelectField
      {...props}
      onSearch={searchDebounce}
    />
  )
}

export default QueueNumberInsuranceSelectField
